import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'hasNot'})
export class HasNotPipe implements PipeTransform {
  transform(values: Array<any>, propertie: string): any {
    return values.filter((item) => {
      return !item.hasOwnProperty(propertie);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/has-not-pipe.ts